import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_COMPLETENURSEASSESMENT_FULFILLED = "FETCH_COMPLETENURSEASSESMENT_FULFILLED";
export const FETCH_COMPLETENURSEASSESMENT_REJECTED = "FETCH_COMPLETENURSEASSESMENT_REJECTED";
export const FETCH_COMPLETENURSEASSESMENT_PENDING = "FETCH_COMPLETENURSEASSESMENT_PENDING";
export const RESET_COMPLETENURSEASSESMENT = "RESET_COMPLETENURSEASSESMENT"

export function completeNurseAssesment(applicationId) {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_COMPLETENURSEASSESMENT",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v3/second-opinion/complete-nurse-assesment?applicationId=${applicationId}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "multipart/form-data",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetCompleteNurseAssesment() {
    return (dispatch) => {
        dispatch({
            type: "RESET_COMPLETENURSEASSESMENT",
        });
    };
}




